<template>
  <div>
    <page-header
      icon="mdi-chart-box-outline"
      :title="$t('routes.canteen_report')"
      :subtitle="$t('manage_meal_reports')"
    >
      <template #actions v-if="!device.isMobile">
        <v-row no-gutters>
          <print-button @click="setPrinter()" class="mr-2" />
          <excel-button @click="setExcel()" class="mr-2" />
        </v-row>
      </template>
    </page-header>

    <page-toolbar v-model="search" :searchable="false">
      <template #filters>
        <v-col cols="6" lg="auto">
          <date-picker v-model="date" color="white" />
        </v-col>

        <v-col cols="6" lg="auto">
          <text-field
            v-model="search"
            kind="search"
            :label="$t('search')"
            color="white"
            hide-details
          />
        </v-col>

        <v-col cols="auto" v-if="!device.isMobile">
          <circle-button
            @click="$store.commit('report/SET_RELOAD')"
            color="blue"
            icon="mdi-reload"
            :tooltip="$t('tooltip_refresh_report')"
          />
        </v-col>
      </template>
    </page-toolbar>

    <div :class="device.isMobile ? 'px-0 mt-2' : 'px-2 mt-2'">
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab v-for="item in items" :key="item.value" :value="item.value">
          <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" :touchless="true">
        <v-tab-item v-for="item in items" :key="item.value">
          <div class="px-2 mt-2">
            <component v-if="tab === item.value" :is="item.component"></component>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- Mobile FAB Menu -->
    <v-speed-dial
      v-if="device.isMobile"
      v-model="fabMenu"
      fixed
      right
      direction="bottom"
      transition="slide-y-reverse-transition"
      style="top: 80px"
    >
      <template v-slot:activator>
        <v-btn v-model="fabMenu" color="grey" fab dark small depressed>
          <v-icon v-if="fabMenu">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <!-- Excel Button -->
      <v-btn fab small color="green darken-2" dark @click="setExcel()">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn>

      <!-- Print Button -->
      <v-btn fab small color="blue-grey" dark @click="setPrinter()">
        <v-icon>mdi-printer</v-icon>
      </v-btn>

      <!-- Reload Button -->
      <v-btn fab small color="blue" dark @click="$store.commit('report/SET_RELOAD')">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasSnackbar from "@/mixins/hasSnackbar";
import CompanyReportTabEmployees from "@/components/company/reports/companyTabs/companyReportTabEmployees.vue";
import CompanyReportTabTakenMeals from "@/components/company/reports/companyTabs/companyReportTabTakenMeals.vue";

import PageHeader from "@/components/global/PageHeader.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";

export default {
  mixins: [hasPrinting, hasExcel, hasSnackbar],
  components: {
    PageHeader,
    PageToolbar,
  },
  data() {
    return {
      fabMenu: false,
      windowSize: { x: 0, y: 0 },
      search: "",
      date: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      tab: 0,
    };
  },
  computed: {
    items() {
      return [
        {
          tab: this.$t("employees"),
          icon: "mdi-account",
          component: CompanyReportTabEmployees,
          value: 0,
        },
        {
          tab: this.$t("t_o"),
          icon: "mdi-check-underline-circle",
          component: CompanyReportTabTakenMeals,
          value: 1,
        },
      ];
    },
  },
  watch: {
    "$store.state.company": {
      handler(val) {
        if (val) {
          this.$store.commit("report/SET_SELECTED_FOOD_COMPANIES", [val]);
        }
      },
      immediate: true,
    },
    search(val) {
      this.$store.commit("report/SET_FILTER", val);
    },
    date(val) {
      if (val[0] == null) {
        val[0] = "";
      }
      if (val[1] == null) {
        val[1] = "";
      }
      this.$store.commit("report/SET_DATE_RANGE", {
        from: val[0],
        to: val[1],
      });
      this.load();
    },
  },
  created() {
    this.load();
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    load() {
      if (this.date[0] && this.date[1]) {
        let from = new Date(this.date[0]);
        let to = new Date(this.date[1]);

        if (from > to) {
          let temp = this.date[0];
          this.date[0] = this.date[1];
          this.date[1] = temp;
        }
      }

      this.$store.commit("report/SET_DATE_RANGE", {
        from: this.date[0],
        to: this.date[1],
      });
      
      if (this.$store.state.company) {
        this.$store.commit("report/SET_SELECTED_FOOD_COMPANIES", [this.$store.state.company]);
      }
    },
  },
};
</script>
